module.exports = __webpack_public_path__ + "img/receivebox_mint4.3d515598.png";